<template>
  <div>
    <FormLayout
      :tabs="this.tabs"
      :leftAction="this.leftAction"
      :onChangeTab="onChangeTabIndex"
    ></FormLayout>
  </div>
</template>

<script>
import Vue from "vue";
import FormLayout from "../../../layouts/FormLayout.vue";
import RoutesPaths from "../../../router/router-structure/routes-paths";

Vue.component("communication-form-view", () =>
  import("./CommunicationForm.vue")
);

export default {
  components: {
    FormLayout,
  },
  async mounted() {
    if (this.$route.params.id) {
      this.leftAction.text = "Editar comunicado";
    }
  },
  data: function() {
    return {
      currentTabIndex: 0,
      leftAction: {
        text: "Novo comunicado",
        onClick: this.leftActionClickHandler,
      },
      leftLinkNavigation: this.leftHistoryNavigation,

      tabs: [
        {
          title: "Informações Gerais",
          formComponent: "communication-form-view",
        },
      ],
    };
  },
  methods: {
    onChangeTabIndex(newValue) {
      this.currentTabIndex = newValue;
    },
    leftActionClickHandler() {
      this.$router.push(RoutesPaths.communicationManagement.rootName());
    },
    leftHistoryNavigation() {
      this.$router.push({
        path: RoutesPaths.requestHistory.rootName(),
        params: {
          serviceType: this.tabs[this.currentTabIndex].serviceType,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
